import { Dispatch } from "redux";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import {
    setApproved,
    setIsEditCertificateModalOpen,
    setSelectedCertificateId,
} from "../../../modals/EditCertificateModal/EditCertificateModalSlice";
import {
    setIsCreateCertificateModalOpen,
    setSelectedQualification,
} from "../../../modals/CreateCertificateModal/CreateCertificateModalSlice";

interface HandleCertificateRenewalParams {
    item: CertificateInterface;
    dispatch: Dispatch;
}

export const handleCertificateRenewal = ({
    item,
    dispatch,
}: HandleCertificateRenewalParams): void => {
    if (item.approved === false) {
        dispatch(setApproved(null));
        dispatch(setSelectedCertificateId(item.id));
        dispatch(setIsEditCertificateModalOpen(true));
        return;
    }

    dispatch(setSelectedQualification(item.qualification));
    dispatch(setIsCreateCertificateModalOpen(true));
};
